import React, { useState } from "react";

import { makeStyles } from "tss-react/mui";
import {
  Card,
  CardActionArea,
  CardMedia,
  Grid,
  Typography,
} from "@mui/material";

import { SolutionsFrame } from "components/solutions/SolutionsFrame";
import { BlockStandard } from "components/admin/BlockStandard";
import { FileUpload } from "components/MUIExtensions/FileUpload";
import { useGreenEnergyContext } from "contexts/GreenEnergyContext";
import { sendBuilding } from "api/onboarding";
import { useToken, useUserContext } from "contexts/UserContext";
import { useSetError } from "contexts/ErrorContext";
import { CustomCodes } from "contexts/ErrorContextData";

const FRAME_DATA = {
  title: "Buscar melhores soluções",
  buttonText: "Continuar",
  nextScreen: "/solutions/diagnosis-congrats",
  skipTo: "/solutions/diagnosis-congrats",
};

const useStyles = makeStyles()((theme) => ({
  gridBase: {
    display: "grid",
    gridGap: `${theme.spacing(3)} ${theme.spacing(2)}`,
    gridTemplateColumns: "repeat(2, 1fr)",
    gridTemplateRows: "repeat(2, 1fr)",
    width: "100%",
  },
  gridItem: {
    borderRadius: "12px",

    "& > button": {
      height: "100%",
      overflow: "hidden",
    },
    "& > button[data-active=true]": {
      border: `2px solid ${theme.palette.primary.main}`,
    },
  },
  uploadWrapper: {
    borderRadius: "12px",
    padding: theme.spacing(2),
    paddingRight: 0,

    "&[data-active=true]": {
      border: `2px solid ${theme.palette.primary.main}`,
    },
  },
}));

const IMG_PRESETS = [
  { src: "/static/img/building-avatars/avatar1.jpg" },
  { src: "/static/img/building-avatars/avatar2.jpg" },
  { src: "/static/img/building-avatars/avatar3.jpg" },
];

export const BuildingAvatar = ({ history }) => {
  const { classes } = useStyles();
  const [avatar, setAvatar] = useState<HTMLInputElement["files"] | string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const token = useToken();
  const {
    building,
    city,
    monthlyCost,
    devices,
    energyGroup,
    energyContractStatus,
    discount,
  } = useGreenEnergyContext();
  const { currentSpace } = useUserContext();
  const setGlobalError = useSetError();

  const handleButton = async () => {
    if (avatar) {
      setIsLoading(true);
      const totalDevices = Object.keys(devices).reduce(
        // @ts-expect-error user can't get here without setting at least one device
        (acc, valueKey) => acc + +devices[valueKey],
        0
      );
      try {
        await sendBuilding(
          token,
          building.name,
          building.type,
          city.city,
          monthlyCost,
          totalDevices,
          energyGroup,
          energyContractStatus,
          discount,
          devices,
          building.invoice,
          avatar,
          currentSpace?.id
        );
        history.push(FRAME_DATA.nextScreen);
      } catch (error) {
        // @ts-expect-error
        setGlobalError(error.response?.data?.error);
      } finally {
        setIsLoading(false);
      }
    } else {
      setGlobalError(CustomCodes.IMAGE_MISSING);
    }
  };

  return (
    <SolutionsFrame
      {...FRAME_DATA}
      onButtonClick={handleButton}
      isLoading={isLoading}
    >
      <BlockStandard hideDivider>
        <Typography variant="h2">Escolha uma imagem para seu imóvel</Typography>

        <Grid className={classes.gridBase}>
          {IMG_PRESETS.map(({ src }) => (
            <Card key={src} className={classes.gridItem}>
              <CardActionArea
                data-active={avatar === src}
                onClick={() => setAvatar(src)}
              >
                <CardMedia>
                  <img alt="" src={src} height="150" />
                </CardMedia>
              </CardActionArea>
            </Card>
          ))}
          <Card
            className={classes.uploadWrapper}
            data-active={!!(avatar && typeof avatar !== "string")}
          >
            <CardActionArea>
              <FileUpload
                // @ts-expect-error if avatar has length, it is an array
                fileName={avatar && avatar.length ? avatar[0].name : ""}
                text="Enviar imagem"
                onFileUpload={(file) => {
                  // @ts-expect-error if avatar has length, it is an array
                  setAvatar(file[0]);
                }}
              />
            </CardActionArea>
          </Card>
        </Grid>
      </BlockStandard>
    </SolutionsFrame>
  );
};
